//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import db from "@/components/firebaseInit";
import SingleLightbox from "../../../components/Pages/SingleLightbox";
import { blogData, blogCategories } from "../../../data/blog";
export default {
  name: "view-blog",
  components: {
    "single-lightbox": SingleLightbox
  },
  data: function data() {
    return {
      id: null,
      image: null,
      content: null,
      title: null,
      category: null,
      date: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    db.collection("blogs").doc(to.params.id).get().then(function (querySnapshop) {
      if (!querySnapshop.exists) {
        console.log("No such document!");
      } else {
        console.log("Document data:", querySnapshop.data());
        next(function (vm) {
          vm.id = to.params.id;
          vm.image = querySnapshop.data().image;
          vm.content = querySnapshop.data().content;
          vm.title = querySnapshop.data().title;
          vm.category = querySnapshop.data().category;
          vm.date = querySnapshop.data().date;
        });
      }
    });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      db.collection("blogs").doc(to.params.id).get().then(function (querySnapshop) {
        if (!querySnapshop.exists) {
          console.log("No such document!");
        } else {
          console.log("Document data:", querySnapshop.data());
          _this.id = querySnapshop.data().id;
          _this.image = querySnapshop.data().image;
          _this.content = querySnapshop.data().content;
          _this.title = querySnapshop.data().title;
          _this.date = querySnapshop.data().date;
        }
      });
    },
    deteteBlog: function deteteBlog() {
      var _this2 = this;

      console.log(this);

      if (confirm("Are you sure?")) {
        db.collection("blogs").doc(this.id).get().then(function (querySnapshop) {
          querySnapshop.ref.delete();

          _this2.$router.push("/app/dashboards/blogs/");
        });
      }
    }
  },
  mounted: function mounted() {}
};